
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IServiceRequestContactSelection } from "@tylertech/tyler-api-types";

/**
 * ServiceRequestContactSelectionService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ServiceRequestContactSelectionService {
    constructor(private readonly $apiService: ApiService) { }
    
    FetchMatchingContacts(requestIdString: string): Promise<IServiceRequestContactSelection> {
        return this.$apiService.sendAuth("IServiceRequestContactSelectionService/FetchMatchingContacts", requestIdString);
    }
}
